"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { generateCalendar } from "@/helpers/calendar/calendar.helpers";
import CommonCalendarDay from "./CommonCalendarDay";
const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
type CommonCalendarProps = {
  readonly initialMonth: number;
  readonly initialYear: number;
  readonly minTimestamp: number | null;
  readonly maxTimestamp: number | null;
  readonly selectedTimestamp: number | null;
  readonly setSelectedTimestamp: (timestamp: number) => void;
};
const getInitialVisibleDate = ({
  initialMonth,
  initialYear,
  selectedTimestamp
}: Pick<CommonCalendarProps, "initialMonth" | "initialYear" | "selectedTimestamp">) => {
  if (selectedTimestamp !== null) {
    const selectedDate = new Date(selectedTimestamp);
    return new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1);
  }
  return new Date(initialYear, initialMonth, 1);
};
function CommonCalendarView(t0) {
  const $ = _c(42);
  const {
    initialMonth,
    initialYear,
    minTimestamp,
    maxTimestamp,
    selectedTimestamp,
    setSelectedTimestamp
  } = t0;
  let t1;
  if ($[0] !== initialMonth || $[1] !== initialYear || $[2] !== selectedTimestamp) {
    t1 = () => getInitialVisibleDate({
      initialMonth,
      initialYear,
      selectedTimestamp
    });
    $[0] = initialMonth;
    $[1] = initialYear;
    $[2] = selectedTimestamp;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const [visibleDate, setVisibleDate] = useState(t1);
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[4] !== maxTimestamp || $[5] !== minTimestamp || $[6] !== selectedTimestamp || $[7] !== setSelectedTimestamp || $[8] !== visibleDate) {
    const month = visibleDate.getMonth();
    const year = visibleDate.getFullYear();
    const days = generateCalendar({
      month,
      year
    });
    let t10;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = () => {
        setVisibleDate(_temp);
      };
      $[17] = t10;
    } else {
      t10 = $[17];
    }
    const setNextMonth = t10;
    let t11;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = () => {
        setVisibleDate(_temp2);
      };
      $[18] = t11;
    } else {
      t11 = $[18];
    }
    const setPreviousMonth = t11;
    t7 = "tw-relative tw-rounded-lg tw-bg-iron-800/60 tw-py-3 tw-shadow-md tw-ring-1 tw-ring-inset tw-ring-iron-700/50";
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <button onClick={setPreviousMonth} type="button" aria-label="Previous month" className="tw-absolute tw-left-1.5 tw-top-1.5 tw-flex tw-items-center tw-justify-center tw-border tw-border-solid tw-border-transparent tw-bg-transparent tw-p-2 tw-text-iron-300 tw-transition tw-duration-300 tw-ease-out hover:tw-text-iron-500"><svg className="tw-h-6 tw-w-6" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg></button>;
      $[19] = t8;
    } else {
      t8 = $[19];
    }
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <button onClick={setNextMonth} type="button" aria-label="Next month" className="tw-absolute tw-right-1.5 tw-top-1.5 tw-flex tw-items-center tw-justify-center tw-border tw-border-solid tw-border-transparent tw-bg-transparent tw-p-2 tw-text-iron-300 tw-transition tw-duration-300 tw-ease-out hover:tw-text-iron-500"><svg className="tw-h-6 tw-w-6" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg></button>;
      $[20] = t9;
    } else {
      t9 = $[20];
    }
    t4 = "tw-text-center";
    const t12 = MONTHS[month];
    if ($[21] !== t12) {
      t5 = <p className="tw-text-base tw-font-medium tw-text-iron-50">{t12}</p>;
      $[21] = t12;
      $[22] = t5;
    } else {
      t5 = $[22];
    }
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <div className="tw-mt-4 tw-grid tw-grid-cols-7 tw-px-3 tw-text-sm tw-font-medium tw-leading-6 tw-text-iron-500"><div>Mo</div><div>Tu</div><div>We</div><div>Th</div><div>Fr</div><div>Sa</div><div>Su</div></div>;
      $[23] = t6;
    } else {
      t6 = $[23];
    }
    t2 = "tw-isolate tw-mt-2 tw-grid tw-grid-cols-7 tw-gap-1.5 tw-px-4";
    let t13;
    if ($[24] !== maxTimestamp || $[25] !== minTimestamp || $[26] !== selectedTimestamp || $[27] !== setSelectedTimestamp) {
      t13 = day => <CommonCalendarDay key={`calendar-${day.startTimestamp}`} day={day} minTimestamp={minTimestamp} maxTimestamp={maxTimestamp} selectedTimestamp={selectedTimestamp} setSelectedTimestamp={setSelectedTimestamp} />;
      $[24] = maxTimestamp;
      $[25] = minTimestamp;
      $[26] = selectedTimestamp;
      $[27] = setSelectedTimestamp;
      $[28] = t13;
    } else {
      t13 = $[28];
    }
    t3 = days.map(t13);
    $[4] = maxTimestamp;
    $[5] = minTimestamp;
    $[6] = selectedTimestamp;
    $[7] = setSelectedTimestamp;
    $[8] = visibleDate;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t2 = $[9];
    t3 = $[10];
    t4 = $[11];
    t5 = $[12];
    t6 = $[13];
    t7 = $[14];
    t8 = $[15];
    t9 = $[16];
  }
  let t10;
  if ($[29] !== t2 || $[30] !== t3) {
    t10 = <div className={t2}>{t3}</div>;
    $[29] = t2;
    $[30] = t3;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  let t11;
  if ($[32] !== t10 || $[33] !== t4 || $[34] !== t5 || $[35] !== t6) {
    t11 = <section className={t4}>{t5}{t6}{t10}</section>;
    $[32] = t10;
    $[33] = t4;
    $[34] = t5;
    $[35] = t6;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  let t12;
  if ($[37] !== t11 || $[38] !== t7 || $[39] !== t8 || $[40] !== t9) {
    t12 = <div className={t7}>{t8}{t9}{t11}</div>;
    $[37] = t11;
    $[38] = t7;
    $[39] = t8;
    $[40] = t9;
    $[41] = t12;
  } else {
    t12 = $[41];
  }
  return t12;
}
function _temp2(currentDate_0) {
  return new Date(currentDate_0.getFullYear(), currentDate_0.getMonth() - 1, 1);
}
function _temp(currentDate) {
  return new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
}
const getResetKey = ({
  initialMonth,
  initialYear,
  selectedTimestamp
}: Pick<CommonCalendarProps, "initialMonth" | "initialYear" | "selectedTimestamp">) => {
  if (selectedTimestamp === null) {
    return `initial-${initialYear}-${initialMonth}`;
  }
  const selectedDate = new Date(selectedTimestamp);
  return ["selected", selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate()].join("-");
};
export default function CommonCalendar(props) {
  const $ = _c(5);
  let t0;
  if ($[0] !== props) {
    t0 = getResetKey(props);
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const resetKey = t0;
  let t1;
  if ($[2] !== props || $[3] !== resetKey) {
    t1 = <CommonCalendarView key={resetKey} {...props} />;
    $[2] = props;
    $[3] = resetKey;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}